import { getFunctions, httpsCallable } from 'firebase/functions';
import app from '../firebase/firebaseConfig';

const REDEEM_ERROR_MESSAGES = {
  'invalid-code': 'That code is not valid. Check for typos and try again.',
  'code-inactive': 'This partner code is no longer active.',
  'code-expired': 'This partner code has expired.',
  'code-maxed': 'This partner code has reached its redemption limit.',
  'already-redeemed': 'You have already redeemed this code.',
  'already-redeemed-partner': 'You have already redeemed a partner code on this account.',
};

function getRedeemErrorMessage(error) {
  const code = typeof error?.message === 'string' ? error.message.trim() : '';
  return REDEEM_ERROR_MESSAGES[code] || 'Could not redeem this code. Please try again.';
}

/**
 * Redeem a bootcamp partner code for the signed-in user.
 * @param {string} code
 * @returns {Promise<{ partnerProUntil: string, monthsFree: number, partnerName: string|null, recommendedRoleId: string|null }>}
 */
export async function redeemPartnerCode(code) {
  const functions = getFunctions(app, 'us-central1');
  const redeem = httpsCallable(functions, 'redeemPartnerCode');

  try {
    const result = await redeem({ code });
    return result.data;
  } catch (error) {
    const message = getRedeemErrorMessage(error);
    const wrapped = new Error(message);
    wrapped.code = error?.message;
    throw wrapped;
  }
}

export { REDEEM_ERROR_MESSAGES, getRedeemErrorMessage };
